import { render, staticRenderFns } from "./sk-date-picker-wap.vue?vue&type=template&id=8bbf2eca&"
import script from "./sk-date-picker-wap.vue?vue&type=script&lang=js&"
export * from "./sk-date-picker-wap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports